/** CloudSign's own small mark: a cloud with a tick, on a rounded square in the brand colour. */
export function LogoMark({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={className} focusable="false">
      <rect width="32" height="32" rx="9" fill="var(--brand-primary)" />
      <path
        d="M10.5 23a4.75 4.75 0 0 1-.9-9.41A6.25 6.25 0 0 1 21.7 12.3 5.35 5.35 0 0 1 22 23H10.5z"
        fill="var(--brand-on-primary)"
      />
      <path d="M12.9 18.2l2.5 2.5 4.7-5" fill="none" stroke="var(--brand-primary)" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
